import { v4 as uuidv4 } from "uuid";

export const getFingerprint = () => {
  let fingerprint = localStorage.getItem("device_uuid");

  if (!fingerprint) {
    fingerprint = uuidv4();
    localStorage.setItem("device_uuid", fingerprint);
  }

  return fingerprint;
};
